export async function bestCurrentUserScore(user, diff) {
  if (user) {
    if (diff !== null) {
      const score = JSON.parse(window.localStorage.getItem("difficulty"));
      if (!score[0][diff] || score[0][diff].score === null) {
        return;
      }
      document.querySelector(
        ".result-BestScore"
      ).innerText = `Jūsų geriausias rezultatas: ${score[0][diff].score}`;
    }
  } else {
    document.querySelector(".result-BestScore").remove();
  }
}
